// Auto-extracted from app.jsx
import { BLOCKER_TYPES } from '../constants/blockerTypes';
import { analyzeBlockers } from './analyzeBlockers';

const QUALITY_SCORE_THRESHOLD = 70;

export function calculateAttestationBlockers(scenarios, thresholds, docReadinessScore = null) {
  const allAnalysis = [
    ...scenarios.map(s => analyzeBlockers(s, "Scenario")),
    ...thresholds.map(t => analyzeBlockers(t, "Threshold")),
  ];
  
  const blockingItems = allAnalysis.filter(a => a.isBlocking);
  const warningItems = allAnalysis.filter(a => !a.isBlocking && a.hasWarnings);
  const readyItems = allAnalysis.filter(a => !a.isBlocking && !a.hasWarnings);
  
  // Group by blocker type for summary
  const blockerSummary = {};
  Object.values(BLOCKER_TYPES).forEach(bt => {
    blockerSummary[bt.id] = {
      ...bt,
      count: 0,
      items: [],
    };
  });
  
  allAnalysis.forEach(a => {
    a.blockers.forEach(b => {
      blockerSummary[b.blockerType.id].count++;
      blockerSummary[b.blockerType.id].items.push({
        ...a.item,
        itemType: a.type,
        blockerReason: b.reason,
        blockerDetails: b.details,
      });
    });
  });
  
  // Check overall quality score threshold (70/100)
  const overallScore = docReadinessScore?.overall_score ?? 
                       docReadinessScore?.score ?? 
                       (allAnalysis.length > 0 
                         ? Math.round(allAnalysis.reduce((sum, a) => sum + (a.eqScore / 9 * 100), 0) / allAnalysis.length)
                         : 100);
  
  const qualityScoreBlocking = overallScore < QUALITY_SCORE_THRESHOLD;
  
  if (qualityScoreBlocking) {
    blockerSummary[BLOCKER_TYPES.LOW_QUALITY_SCORE.id] = {
      ...BLOCKER_TYPES.LOW_QUALITY_SCORE,
      count: 1,
      items: [{
        name: `Overall Quality Score: ${overallScore}%`,
        itemType: "System",
        blockerReason: `Quality score is ${overallScore}%, below the required ${QUALITY_SCORE_THRESHOLD}%`,
        blockerDetails: [
          `Current: ${overallScore}%`,
          `Required: ${QUALITY_SCORE_THRESHOLD}%`,
          "Improve WHY rationales and add evidence to increase score"
        ],
      }],
    };
  }
  
  const totalItems = scenarios.length + thresholds.length;
  const readyCount = readyItems.length;
  const readyPercent = totalItems > 0 ? Math.round((readyCount / totalItems) * 100) : 0;
  
  return {
    canAttest: blockingItems.length === 0 && !qualityScoreBlocking,
    hasWarnings: warningItems.length > 0,
    totalItems,
    readyCount,
    readyPercent,
    overallScore,
    qualityScoreBlocking,
    blockingItems,
    warningItems,
    readyItems,
    blockerSummary: Object.values(blockerSummary).filter(b => b.count > 0),
  };
}
